<template>
    <v-container grid-list-xl fluid class="ml-6 mr-6">
        <v-layout row wrap>
                <v-flex xs6 class="pl-6">
                    <v-row> <h1>Routes For {{currentUser ? (currentUser.firstName + ' ' + currentUser.lastName ) : ''}}</h1></v-row>
                    <v-row> Click a row to view tasks</v-row>
                </v-flex>
        </v-layout>
        <v-layout row wrap class="pr-12">
            <v-flex xs6>
                <v-card>
                    <v-data-table
                        :headers="routeHeaders"
                        :items="routesForWorker"
                        item-key="id"
                        class="elevation-1"
                        @click:row="handleRowClick">
                        <template v-slot:item.action="{ item }">
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-icon
                                        v-on="on"
                                        class="mr-2"
                                        color="blue"
                                        @click="openRouteDetails(item)">
                                        mdi-information-outline
                                    </v-icon>
                                </template>
                                <span>Route Information</span>
                            </v-tooltip>
                            <v-tooltip top v-if="item && !item.complete">
                                <template v-slot:activator="{ on }">
                                    <v-icon
                                        v-on="on"
                                        class="mr-2"
                                        color="green"
                                        @click="completeRoute(item)">
                                        mdi-check-circle-outline
                                    </v-icon>
                                </template>
                                <span>Complete Route</span>
                            </v-tooltip>
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-icon
                                        v-on="on"
                                        class="mr-2"
                                        color="black"
                                        @click="archiveRoute(item)">
                                        mdi-archive
                                    </v-icon>
                                </template>
                                <span>Archive Route</span>
                            </v-tooltip>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
            <v-flex xs6>
                <v-card>
                    <v-data-table
                        :headers="taskHeaders"
                        :items="selectedRouteForTable.displayTasks"
                        :options="tableOptions"
                        item-key="taskNumber"
                        class="elevation-1">
                        <template v-slot:item.action="{ item }">
                            <v-row >
                                <v-tooltip top v-if="item.jobTask.status !== 'Complete'">
                                    <template v-slot:activator="{ on }">
                                        <v-icon
                                            v-on="on"
                                            class="mr-2"
                                            color="green"
                                            @click="completeDialogForJobTask(item)">
                                            mdi-check-circle-outline
                                        </v-icon>
                                    </template>
                                    <span>Complete Task</span>
                                </v-tooltip>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <v-icon
                                            v-on="on"
                                            class="mr-2"
                                            color="blue"
                                            @click="handleDetails(item)">
                                            mdi-information-outline
                                        </v-icon>
                                    </template>
                                    <span>Task Details</span>
                                </v-tooltip>
                            </v-row>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
            <archive-route :toggle="toggleArchive" :show-dialog="archiveDialog" :route="selectedRoute" :incompleteTasks="incompleteTasks"></archive-route>
            <route-details :action-type="detailsType" :toggle="toggleRouteDetails" :show-dialog="routeDetails" :show-remove-task-dialog="removeTaskFromRoute" :show-task-details-dialog="handleInnerTaskDetails" :show-remove-user-dialog="removeUserFromTask"></route-details>
            <task-details  id="inner-task-details" :show-dialog="innerTaskDetails" :toggle="toggleInnerTaskDetails"></task-details>
            <task-details id="outer-task-details"  :show-dialog="outerTaskDetails" :toggle="toggleOuterTaskDetails" ></task-details>
            <unassign-task :show-dialog="removeTaskDialog" :toggle="toggleRemoveTaskDialog" :job-task="jobTaskForInnerDetails"></unassign-task>
            <remove-user-from-task :show-dialog="removeUserDialog" :toggle="toggleRemoveUserDialog" :user="selectedUser"></remove-user-from-task>
            <complete-route :showDialog="completeRouteDialog" :toggle="toggleCompleteRoute" :route="selectedRoute"  :incompleteTasks="incompleteTasks"></complete-route>

            <complete-jobTask :showDialog="completeJobTaskDialog" :toggle="toggleCompleteTask"  :jobTask="jobTaskToComplete"></complete-jobTask>
        </v-layout>
    </v-container>
</template>
<script>
    import ArchiveRoute from '../../../components/routes/Archive'
    import CompleteRoute from '../../../components/routes/Complete'
    import CompleteJobTask from '../../../components/jobTasks/Complete'
    import RouteDetails from '../../../components/routes/Details'
    import {mapActions, mapGetters} from 'vuex'
    import UnassignTask from "../../../components/jobTasks/UnassignTask";
    import TaskDetails from "../../../components/jobTasks/Details";
    import RemoveUserFromTask from "../../../components/users/RemoveUserFromTask";
    import Helpers from "../../../utils/helpers/routeHelpers"

    export default {
        name: 'worker-routes',
        components: {
            RemoveUserFromTask,
            TaskDetails,
            ArchiveRoute,
            CompleteRoute,
            UnassignTask,
            RouteDetails,
            CompleteJobTask,

        },
        created () {
            this.getAllRoutes()
        },
        data () {
            return {
                //For route table
                archiveDialog: false,
                routeDetails: false,
                removeTaskDialog: false,
                removeUserDialog: false,
                completeRouteDialog: false,
                selectedUser: null,
                routeForDetails: null,
                tableKey: 0,
                detailsType: '',

                selectedRouteForTable: {},

                //for collapsible task table
                tableOptions: {
                    itemsPerPage: 10
                },
                outerTaskDetails: false,
                jobTaskForOuterDetails: {},

                innerTaskDetails: false,
                jobTaskForInnerDetails: {},

                jobTaskToComplete: {},
                completeJobTaskDialog: false,
            }
        },
        methods: {
            ...mapActions({
                getAllRoutes: 'routes/getAll',
                getRouteById: 'routes/getById',
                getIsolatedRoute: 'routes/getIsolatedRoute',
                selectRoute: 'routes/selectRoute',
                clearSelectedRoute: 'routes/clearSelectedRoute',
                completeTask: 'jobTasks/complete',
                selectTask: 'jobTasks/getById'
            }),
            async createRouteProcess () {
                this.clearSelectedRoute()
                let route = {
                    name: null,
                    id: null,
                    duration: '00:00:00',
                    color: Helpers.getRandomColour(),
                    jobTasks: [],
                    userRoutes: [],
                }
                this.detailsType = 'create'
                this.selectRoute(route)
                this.toggleRouteDetails()
            },
            async removeTaskFromRoute (task) {
                this.jobTaskForOuterDetails = task
                await this.toggleRemoveTaskDialog()
            },
            async removeUserFromTask (user) {
                this.selectedUser = user
                await this.toggleRemoveUserDialog()
            },
            toggleRemoveTaskDialog () {
                this.removeTaskDialog = !(this.removeTaskDialog)
            },
            async handleInnerTaskDetails (task) {
                this.jobTaskForInnerDetails = task
                await this.toggleInnerTaskDetails()
            },
            toggleInnerTaskDetails () {
                this.innerTaskDetails = !(this.innerTaskDetails)
            },
            async completeRoute(route) {
                await this.selectRoute(route)
                await this.toggleCompleteRoute()
            },
            async openRouteDetails(item) {
                this.getIsolatedRoute(item.id)
                this.detailsType = 'update'
                await this.toggleRouteDetails()
            },
            async archiveRoute(route) {
                await this.selectRoute(route)
                await this.toggleArchive()
            },
            async toggleArchive () {
                if(this.archiveDialog){ //reload the selected route on closing the modal
                    await this.reloadSelectedRoute()
                }
                this.archiveDialog = !(this.archiveDialog)
            },
            async toggleRouteDetails () {
                if(this.routeDetails){ //reload the selected route on closing the modal
                    await this.reloadSelectedRoute()
                }
                this.routeDetails = !(this.routeDetails)
            },
            async toggleCompleteRoute() {
                if(this.completeRouteDialog){ //reload the selected route on closing the modal
                    await this.reloadSelectedRoute()
                }
                this.completeRouteDialog = !(this.completeRouteDialog)
            },
            async toggleCompleteTask() {
                if(this.completeJobTaskDialog){ //reload the selected route on closing the modal
                   await this.reloadSelectedRoute()
                }
                this.completeJobTaskDialog = !(this.completeJobTaskDialog)
            },
            async toggleOuterTaskDetails() {
                if(this.outerTaskDetails){  //reload the selected route on closing the modal
                    await this.reloadSelectedRoute()
                }
                this.outerTaskDetails = !(this.outerTaskDetails)
            },
            toggleRemoveUserDialog () {
                this.removeUserDialog = !(this.removeUserDialog)
            },
            completeDialogForJobTask(item) {
                this.jobTaskToComplete = item.jobTask
                this.jobTaskForDetails.route = {id: this.selectedRouteForTable.id}
                this.toggleCompleteTask()
            },
            handleDetails(item) {
                this.selectTask(item.jobTask.id)
                this.toggleOuterTaskDetails()
            },
            handleRowClick(route){
                this.selectedRouteForTable = route
            },
            async reloadSelectedRoute(){
               await this.getRouteById(this.selectedRouteForTable.id)
                this.selectedRouteForTable = this.selectedRoute
                this.selectedRouteForTable.displayTasks = Helpers.getDisplayTasks(this.selectedRoute)
            }

        },
        computed: {
            ...mapGetters({
                routes: 'routes/routes',
                currentUser: 'user/currentUser',
                selectedRoute: 'routes/selectedRoute',
                incompleteTasks: 'routes/selectedRouteIncompleteTasks',
                routeHeaders: 'routes/workerHeaders',
                taskHeaders: 'jobTasks/workerHeaders',
                error: 'routes/error',
            }),
            routesForWorker: {
                get() {
                    if (!Array.isArray(this.routes))
                        return [this.routes]
                    if(!this.routes){
                        return
                    }
                    this.routes.map(route => {
                        route.crew = Helpers.getCrewNames(route)
                        route.complete = Helpers.getCompletionStatus(route)
                        route.displayTasks = Helpers.getDisplayTasks(route)
                    })
                    //only show routes with the current user added
                    if(!this.currentUser){
                        return []
                    }
                    return this.routes.filter(route => {
                        let add = false;
                        route.userRoutes.forEach(ur => {
                            if(ur.userId === this.currentUser.id){
                                add = true
                            }
                        })
                        return add
                    })
                },
                set () {
                    this.getAllRoutes()
                }
            }
        }
    }
</script>
